import { LoomIcon } from '@atlaskit/logo';

import { DEFAULT_CLOUD_GRAPH_VIDEO_ENTITY_ATI } from '../../entities';
import { NounSubtypeKey, TypeFilterValueKey } from '../../filters/universal-type';
import { RovoLogoFromLogo } from '../../icons';
import { type ThirdPartyConfig } from '../../schemas/3p-config';

export const loomConfig: ThirdPartyConfig = {
	displayName: 'Loom',
	id: 'loom',
	icon: RovoLogoFromLogo(LoomIcon, 'small'),
	searchResultIcon: RovoLogoFromLogo(LoomIcon, 'large'),
	integrationAri: 'ari:cloud:platform::integration/loom',
	typeFilterConfig: new Map([
		[
			TypeFilterValueKey.Video,
			{
				entities3P: DEFAULT_CLOUD_GRAPH_VIDEO_ENTITY_ATI,
				subTypes3P: [NounSubtypeKey.Video],
			},
		],
	]),
	filters: ['lastUpdated'],
	requiresOauth: false,
	isEnabled: () => true,
};
